import React from "react";
import DisplayError from "../../common/DisplayError";
import RadioOption from "../RadioOption";
import "./RadioField.css";
import HtmlElement from "../../common/HtmlElement";
import type { StandardFieldProps } from "../types";
import { useFormContext } from "react-hook-form/dist/useFormContext";


const RadioField: React.FC<StandardFieldProps> = (props) => {
  const { field, error } = props;

  return (
    <div className="main-container mb-2">
      <HtmlElement elements={`${field.label}:`} />
      <div className="radio-options-container">
        {field.options?.map((opt) => (
          <RadioOption
            key={`${field.name}_${opt.key}`}
            field={field}
            opt={opt}
            validationsObject={props.validationsObject}
          />
        ))}
      </div>
      <DisplayError
        hideEmptyError={true}
        errorCondition={error}
        errorMessage={error && error.message}
      />
    </div>
  );
};

export default RadioField;
